import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { tutorAuthService } from '../services/tutorAuth';
import ComplementCadastroModal from './ComplementCadastroModal';
import './ComplementCadastroModal.css';

/**
 * Modal obrigatório de complemento de cadastro (telefone). Quando o tutor está logado
 * e não possui telefone, bloqueia o uso do site até preencher. Recheca a cada navegação
 * para abrir após login (ex.: Google).
 */
const ComplementCadastroGate: React.FC = () => {
  const { pathname } = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!tutorAuthService.isAuthenticated()) {
      setChecked(true);
      setShowModal(false);
      return;
    }
    setChecked(false);
    tutorAuthService
      .getCurrentTutor()
      .then((tutor) => {
        const phone = tutor.telefone?.trim();
        if (!phone) setShowModal(true);
        else setShowModal(false);
      })
      .catch(() => setShowModal(false))
      .finally(() => setChecked(true));
  }, [pathname]);

  if (!checked || !showModal) return null;

  return (
    <div className="complement-cadastro-gate" aria-modal="true" role="dialog">
      <ComplementCadastroModal
        onComplete={() => setShowModal(false)}
      />
    </div>
  );
};

export default ComplementCadastroGate;
